var _circle, _path, _circle2, _circle3, _circle4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconContainer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.966,
    cy: 47.9065,
    r: 36.6726,
    fill: "#180673"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.9365 44.9661C83.9365 66.4889 66.4889 83.9365 44.9661 83.9365C23.4433 83.9365 5.99561 66.4889 5.99561 44.9661C5.99561 23.4433 23.4433 5.99561 44.9661 5.99561C66.4889 5.99561 83.9365 23.4433 83.9365 44.9661Z",
    fill: "#294256"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.9659,
    cy: 44.9659,
    r: 39.1212,
    stroke: "url(#paint0_linear_163_192)",
    strokeWidth: 8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.9659,
    cy: 44.9657,
    r: 41.0047,
    stroke: "url(#paint1_linear_163_192)",
    strokeWidth: 7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.9659,
    cy: 44.9659,
    r: 43.4659,
    stroke: "url(#paint2_linear_163_192)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_163_192",
    x1: 44.9659,
    y1: 1.84473,
    x2: 44.9659,
    y2: 88.0871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#381188",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_163_192",
    x1: 44.9659,
    y1: 0.460937,
    x2: 44.9659,
    y2: 89.4704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B4257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B4257",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_163_192",
    x1: 44.9659,
    y1: 0,
    x2: 44.9659,
    y2: 89.9318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D8167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D8167",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContainer);
export default __webpack_public_path__ + "static/media/IconContainer.2ad7a83f3538bd445ac6845ab1dca82a.svg";
export { ForwardRef as ReactComponent };